import { useUnit } from 'effector-react';
import $$ep from 'models/ep';
import { $global } from 'models/store-global';

import Dropdown from 'components/StyledTemplates/Dropdown';
import { Option } from 'components/Table/Table';
import { MoreButton } from 'components/pages/Dashboard/common/CommunityPageStyles';
import { DashboardButton } from 'components/pages/Dashboard/common/DashboardPageStyles';

import DashboardService from 'services/DashboardService';

import useResources from 'hooks/useResources';

type EpActionBlockProps = {
    updateText?: string;
};

const EpActionsBlock = (props: EpActionBlockProps) => {
    const { t } = useResources();

    const epExists = useUnit($$ep.stores.$epQInstanceId.map(Boolean));
    const community = useUnit($global.map((state) => state.community));

    const handlers = {
        requestEstatePlanUpdate: DashboardService.requestEstatePlanUpdate,
        printAllEstatePlanDocuments: DashboardService.printAllEstatePlanDocuments,
        requestEstatePlanDelete: DashboardService.requestEstatePlanDelete,
    };

    return (
        <div className="d-flex gap-2">
            <DashboardButton
                data-qaid="update_ep_button"
                variant="outline-secondary"
                onClick={handlers.requestEstatePlanUpdate}
            >
                {props.updateText || t('newDashboardPage.updateAll')}
            </DashboardButton>
            <Dropdown
                toggle={<MoreButton data-qaid="plan_options_button" />}
                menu={[
                    {
                        children: t('newDashboardPage.printAll'),
                        onClick: handlers.printAllEstatePlanDocuments,
                        visible: !!community?.docs?.length,
                    },
                    {
                        children: t('newDashboardPage.delete'),
                        onClick: handlers.requestEstatePlanDelete,
                        visible: epExists,
                    },
                ]
                    .filter((i) => i.visible)
                    .map(({ visible, ...item }) => item)
                    .map((item, index) => (
                        <Option key={index} {...item} />
                    ))}
            />
        </div>
    );
};

export default EpActionsBlock;
